module.exports = __webpack_public_path__ + "media/images/metronic/social/stumbleupon-3cb600f3ca1e01e2dd0e3385f6b0a6b3.png";